import React, { useState } from 'react';
import { Alert,TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,  Container,  Form,  FormGroup, Label, Input, FormText  } from 'reactstrap';
import classnames from 'classnames';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdMyLocation } from 'react-icons/md';
import { FaInfoCircle } from 'react-icons/fa';


var tabActual = 1;
var tabActualString = 1;
const TabsForm = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    let class1 = "";
    let class2 = "";
    let class3 = "";
   
    let btnSiguiente = "btnOculto";
    console.log(props.state)
    const toggle = tab => {
        console.log(tab)
        btnSiguiente = true;

        var element, name, arr;
        element = document.querySelectorAll('.btn.btn-success.btnSiguiente')[0]
        name = "btnOculto";
        arr = element.className
        if (arr.indexOf(name) == -1) {
            element.className += " " + name;
        }
        var i=0
        do {
          var  i = i + 1;
         
            var elems = document.querySelectorAll(".nav.nav-tabs li:nth-child(" + i + ") .row .navActiveButton.textoCentrado");

            [].forEach.call(elems, function (el) {
                el.className = el.className.replace(/\bActivarMenuItem\b/, "");
            });
        } while (i < 8);

        if (tab == 1) {
         

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 1);


       

        }
        else if (tab == 2) {
            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child('+i+') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 2);

          

          

        }
        else if (tab == 3) {

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 3);
        }
        else if (tab == 4) {

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 4);
        }
        else if (tab == 5) {

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 5);
        }
        else if (tab == 6) {

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 6);
        }
        else if (tab == 7) {

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 7);
        }

        else if (tab == 8) {

            var elems = document.querySelectorAll(".btn.btn-success.btnOculto.btnSiguiente");

            [].forEach.call(elems, function (el) {
                el.className = el.className.replace(/\bbtnOculto\b/, "");
            });

            var i = 0;
            do {
                i = i + 1;
                var element, name, arr;
                element = document.querySelectorAll('.nav.nav-tabs li:nth-child(' + i + ') .row .textoCentrado ')[0]
                name = "ActivarMenuItem";
                arr = element.className.split(" ");
                if (arr.indexOf(name) == -1) {
                    element.className += " " + name;
                }
            } while (i < 8);
        }



        tabActual = tab
        tabActualString = tabActual
        if (activeTab !== tab) setActiveTab(tab);
    }
  
   
    const handleChangeTabs = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangeTabs(e.target.value, e.target.name,props )
       
    }

    const handleChangehidestatusEdoCivil = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangehidestatusEdoCivil(e.target.value, e.target.name, props)

    }

    
    const handleChangehideOtroTypeHousing = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangehideOtroTypeHousing(e.target.value, e.target.name, props)

    }
    const handleChangeDestinodelCredito = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangeDestinodelCredito(e.target.value, e.target.name, props)

    }
    const handleChangePostalCode = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        console.log(props.state.PostalCode)
        props.handleChangePostalCode(props.state.PostalCode,'PostalCode', props)

    }

    const handleChangeMontoPosibleApagar = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleChangeMontoPosibleApagar(e.target.value, e.target.name, props)

    }
    const SaveValidateFormAdjunto = (e) => {
        console.log(e.target.value)
        console.log(e.target)
      
       
        props.SaveValidateFormAdjunto(e.target.value, e.target.name, props)

    }
    const displayProcessR = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.displayProcessR()

    }
    const handleCheck = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleCheck()

    }
    const handleCheckCartaPoder = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.handleCheckCartaPoder()

    }

    
   


    const cancelarPantalla = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.cancelarPantalla()

    }

    const SaveValidateForm = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.SaveValidateForm()

    }

    const ValidateForm = (e) => {
        console.log(e.target.value)
        console.log(e.target)
        props.ValidateForm()

    }

    const NavigateNext = (e) => {

        if (tabActual == 8) {

        } else {
            tabActual = parseInt(tabActual) + 1
            console.log(tabActual)
            tabActualString = tabActual;
            toggle(tabActualString.toString())
            classnames({ active: tabActualString.toString() })
        }
       

    }

    const NavigateBefore = (e) => {
  
        if (tabActual == 1) {

        } else {
            tabActual = parseInt(tabActual) - 1
            console.log(tabActual)
            tabActualString = tabActual;
            toggle(tabActualString.toString())
            classnames({ active: tabActualString.toString() })
        }

    }
    
    const AlertaInfoUbicacion = () => {



        props.AlertaInfoUbicacion()

    
    }
    const UbicarPesona = () => {



        props.UbicarPesona()

        console.log(window.UbicacionPersona)
    }


   
    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '1' }) } onClick={() => { toggle('1'); }} >
                        <Row>
                            <Col className={props.state.validadorTab1Class}>
                                <div>1</div>
                            </Col>
                           
                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Datos Personales</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '2' } )  } onClick={() => { toggle('2'); }}>
                        <Row>
                            <Col className={props.state.validadorTab2Class} >
                                <div>2</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Información de domicilio</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '3' }) } onClick={() => { toggle('3'); }}>
                        <Row>
                            <Col className={props.state.validadorTab3Class} >
                                <div>3</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Información laboral</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '4' })} onClick={() => { toggle('4'); }}>
                        <Row>
                            <Col className={props.state.validadorTab4Class} >
                                <div>4</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Información de crédito</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '5' })} onClick={() => { toggle('5'); }}>
                        <Row>
                            <Col className={props.state.validadorTab5Class}>
                                <div>5</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Referencia</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '6' })} onClick={() => { toggle('6'); }}>
                        <Row>
                            <Col className={props.state.validadorTab6Class} >
                                <div>6</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Documentos</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '7' })} onClick={() => { toggle('7'); }}>
                        <Row>
                            <Col className={props.state.validadorTab7Class}>
                                <div>7</div>
                            </Col>

                        </Row> 
                        <div className="LineHorizontal"></div>
                    </NavLink><div className="textMenu">Autorización</div>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === '8' })} onClick={() => { toggle('8'); }}>
                        <Row>
                            <Col className={props.state.validadorTab8Class}>
                                <div>8</div>
                            </Col>

                        </Row>
                    </NavLink><div className="textMenu">Compartir localización</div>
                </NavItem>
            </Nav>
            <br />
            <br />  
            <TabContent activeTab={activeTab} className="shadow p-3  bg-white ">
                

                  
                <TabPane tabId="1">

                    <div className="rowTitle">
                        <h5 className="PageHeading">DATOS PERSONALES</h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>

                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>

                           
                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={4}> <FormGroup row><Label for="ApellidoP" sm={12}>Apellido Paterno*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="ApellidoP" onChange={handleChangeTabs} value={props.state.ApellidoP} /></Col> </FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="ApellidoM" sm={12}>Apellido Materno*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="ApellidoM" onChange={handleChangeTabs} value={props.state.ApellidoM} /></Col> </FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="Nombres" sm={12}>Nombres*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Nombres" onChange={handleChangeTabs} value={props.state.Nombres} /></Col> </FormGroup></Col>
                        <Col sm={4} md={4} lg={2}><FormGroup row><Label for="Genero" sm={12}>Género*</Label><Col sm={12}><Input disabled bsSize="sm" type="select" name="Genero" onChange={handleChangeTabs} value={props.state.Genero} >
                            <option>Seleccione</option>
                                    <option>MASCULINO</option>
                            <option>FEMENINO</option></Input></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Genero"]}</span></FormGroup></Col>

                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="lugar_Nacimiento" sm={12}>lugar de Nacimiento*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="lugar_Nacimiento" onChange={handleChangeTabs} value={props.state.lugar_Nacimiento} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_lugar_Nacimiento"]}</span></FormGroup></Col>
                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="Nacionalidad" sm={12}>Nacionalidad*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Nacionalidad" onChange={handleChangeTabs} value={props.state.Nacionalidad} /></Col>  <span className="col-sm-12 errorInput">{props.state.errors["Error_Nacionalidad"]}</span></FormGroup></Col>
                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="Pais_Nacimiento" sm={12}>País de Nacimiento*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Pais_Nacimiento" onChange={handleChangeTabs} value={props.state.Pais_Nacimiento} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_Pais_Nacimiento"]}</span></FormGroup></Col>
                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="RFC_Homoclave" sm={12}>R.F.C. Homoclave*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="RFC_Homoclave" onChange={handleChangeTabs} value={props.state.RFC_Homoclave} /></Col>  <span className="col-sm-12 errorInput">{props.state.errors["Error_RFC_Homoclave"]}</span></FormGroup></Col>
                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="CURP" sm={12}>CURP*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="CURP" onChange={handleChangeTabs} value={props.state.CURP} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_CURP"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="Fecha_Nacimiento" sm={12}>Fecha de Nacimiento*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Fecha_Nacimiento" onChange={handleChangeTabs} value={props.state.Fecha_Nacimiento} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Fecha_Nacimiento"]}</span>  </FormGroup></Col>
                                <Col sm={4}> <FormGroup row><Label for="Tipo" sm={12}>Tipo*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Tipo" onChange={handleChangeTabs} value={props.state.Tipo} /></Col><span className="col-sm-12 errorInput">{props.state.errors["Error_Tipo"]}</span></FormGroup></Col>

           
                                <Col sm={4} hidden={props.state.hidePasaporte}> <FormGroup row><Label for="OfficialIdNumber2" sm={12}>CIC</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="OfficialIdNumber2" onChange={handleChangeTabs} value={props.state.OfficialIdNumber2} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_OfficialIdNumber2"]}</span></FormGroup></Col>
                                <Col sm={4} hidden={props.state.hidePasaporte}> <FormGroup row><Label for="OfficialIdNumber3" sm={12}>Identificador del ciudadano</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="OfficialIdNumber2" onChange={handleChangeTabs} value={props.state.OfficialIdNumber3} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_OfficialIdNumber3"]}</span></FormGroup></Col>
                                <Col sm={4}> <FormGroup row><Label for="Num_ident_Oficial_Vigente" sm={12}>{props.state.labelTipo}</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Num_ident_Oficial_Vigente" onChange={handleChangeTabs} value={props.state.Num_ident_Oficial_Vigente} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_Num_ident_Oficial_Vigente"]}</span></FormGroup></Col>



                        <Col sm={4}> <FormGroup row><Label for="Correo" sm={12}>Correo Electrónico*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Correo" onChange={handleChangeTabs} value={props.state.Correo} /></Col> </FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="Telf_Particular" sm={12}>Teléfono Particular*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Telf_Particular" onChange={handleChangeTabs} value={props.state.Telf_Particular} /></Col> <span className="col-sm-12 errorInput">{props.state.errors["Error_Telf_Particular"]}</span></FormGroup></Col>


                        <Col sm={4}> <FormGroup row><Label for="Cellphone2" sm={12}>Otro telf.</Label><Col sm={12}><Input bsSize="sm" type="text" name="Cellphone2" onChange={handleChangeTabs} value={props.state.Cellphone2} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Cellphone2"]}</span></FormGroup></Col>


                        <Col sm={4}> <FormGroup row><Label for="MaximumDegreeStudies" sm={12}>Grado Máximo Estudios*</Label><Col sm={12}>
                            <Input bsSize="sm" type="select" name="MaximumDegreeStudies" onChange={handleChangeTabs} value={props.state.MaximumDegreeStudies} >
                                        <option>SELECCIONE</option>
                                        {props.state.Catalogo.filter(item => item.tipo == 'GRADO MÁXIMO DE ESTUDIOS').map(item => <option>{item.nombre}</option>)}
                            </Input>
                        </Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_MaximumDegreeStudies"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="MaritalStatus" sm={12}>Estado Civil*</Label><Col sm={12}>
                            <Input bsSize="sm" type="select" name="MaritalStatus" onChange={handleChangehidestatusEdoCivil} value={props.state.MaritalStatus} >
                                        <option>SELECCIONE</option>
                                <option>SOLTERO/A</option>
                                <option>CASADO/A</option></Input>
                        </Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_MaritalStatus"]}</span></FormGroup></Col>
                        <Col sm={4} hidden={props.state.statusEdoCivil}> <FormGroup row><Label for="SpousalRegime" sm={12}>Regimen conyugal*</Label><Col sm={12}><Input bsSize="sm" type="text" name="SpousalRegime" onChange={handleChangeTabs} value={props.state.SpousalRegime} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_SpousalRegime"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="NumEconomicDependents" sm={12}>Núm. Dependientes economicos.*</Label><Col sm={12}><Input bsSize="sm" type="number" name="NumEconomicDependents" onChange={handleChangeTabs} value={props.state.NumEconomicDependents} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NumEconomicDependents"]}</span></FormGroup></Col>





                    </Row>

                   
                    <div hidden={props.state.statusEdoCivil} className="rowSubTitle">
                        <h5 hidden={props.state.statusEdoCivil} className="PageHeading">INFORMACIÓN DEL CÓNYUGE </h5>
                    </div>
         
                    <Row hidden={props.state.statusEdoCivil} className="rowGris">
                        <Col sm={4}> <FormGroup row><Label for="FullNameSpouse" sm={12}>Nombre completo cónyuge </Label><Col sm={12}><Input bsSize="sm" type="text" name="FullNameSpouse" onChange={handleChangeTabs} value={props.state.FullNameSpouse} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_FullNameSpouse"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="CellphoneSpouse" sm={12}>Celular</Label><Col sm={12}><Input bsSize="sm" type="text" name="CellphoneSpouse" onChange={handleChangeTabs} value={props.state.CellphoneSpouse} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_CellphoneSpouse"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="BusinessSpouse" sm={12}>Empresa</Label><Col sm={12}><Input bsSize="sm" type="text" name="BusinessSpouse" onChange={handleChangeTabs} value={props.state.BusinessSpouse} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_BusinessSpouse"]}</span></FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="OccupationSpouse" sm={12}>Ocupación </Label><Col sm={12}><Input bsSize="sm" type="text" name="OccupationSpouse" onChange={handleChangeTabs} value={props.state.OccupationSpouse} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_OccupationSpouse"]}</span></FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="CompanyPhoneSpouse" sm={12}>Telf. Empresa</Label><Col sm={12}><Input bsSize="sm" type="text" name="CompanyPhoneSpouse" onChange={handleChangeTabs} value={props.state.CompanyPhoneSpouse} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_CompanyPhoneSpouse"]}</span></FormGroup></Col>
                    </Row>
                        </Col>
                            <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                            </Col>
                    </div>
                            <br /> <br />
                           
                     
              
                </TabPane>
                <TabPane tabId="2">
                 
                    
                    <div className="rowTitle">
                        <h5 className="PageHeading">INFORMACIÓN DE DOMICILIO </h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>
                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>
                            

                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={4}> <FormGroup row><Label for="PostalCode" sm={12}>Código Postal*</Label><Col sm={12}>
                            <Input bsSize="sm" type="text" name="PostalCode" onChange={handleChangeTabs}  value={props.state.PostalCode} />

                        </Col>
                                    <span className="col-sm-12 errorInput">{props.state.errors["Error_PostalCode"]}</span></FormGroup></Col>


                                <Col sm={4}> <FormGroup row>
                                    <Col sm={12}> 
                                        <button type="button" onClick={handleChangePostalCode} className="btn btn-success btnSEPOMEX">Buscar en SEPOMEX</button>
                                    </Col>
                                </FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="CologneFractionation" sm={12}>Colonia / Fraccionamiento*</Label><Col sm={12}>
                            <Input bsSize="sm" type="select" name="CologneFractionation" onChange={handleChangeTabs} value={props.state.CologneFractionation} >
                                        <option>SELECCIONE</option>
                                        {props.state.Sepomex.map(item => <option>{item.dasenta.toUpperCase()}</option>)}

                            </Input>
                        </Col>
                                    <span className="col-sm-12 errorInput">{props.state.errors["Error_CologneFractionation"]}</span></FormGroup></Col>

                          



                        <Col sm={4}> <FormGroup row><Label for="DelegationMunicipality" sm={12}>Delegación/Municipio*</Label><Col sm={12}>
                            <Input bsSize="sm" disabled type="text" name="DelegationMunicipality" onChange={handleChangeTabs} value={props.state.DelegationMunicipality} />

                        </Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_DelegationMunicipality"]}</span></FormGroup></Col>


                                <Col sm={4}> <FormGroup row><Label for="City" sm={12}>Ciudad*</Label><Col sm={12}><Input bsSize="sm" type="text" disabled={props.state.bloquearCiudad} name="City" onChange={handleChangeTabs} value={props.state.City} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_City"]}</span></FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="State" sm={12}>Estado*</Label><Col sm={12}><Input bsSize="sm" type="text" disabled name="State" onChange={handleChangeTabs} value={props.state.State} />

                        </Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_State"]}</span></FormGroup></Col>








                        <Col sm={8}> <FormGroup row><Label for="AddressDetail" sm={12}>Calle/Avenida/Vía*</Label><Col sm={12}><Input bsSize="sm" type="text" name="AddressDetail" onChange={handleChangeTabs} value={props.state.AddressDetail} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_AddressDetail"]}</span></FormGroup></Col>

                                <Col sm={4}> <FormGroup row><Label for="NumExt" sm={12}>Número Exterior*</Label><Col sm={12}><Input bsSize="sm" type="text" name="NumExt" onChange={handleChangeTabs} value={props.state.NumExt} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NumExt"]}</span></FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="NumInt" sm={12}>Número Interior*</Label><Col sm={12}><Input bsSize="sm" type="text" name="NumInt" onChange={handleChangeTabs} value={props.state.NumInt} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NumInt"]}</span></FormGroup></Col>



                        <Col sm={4}> <FormGroup row><Label for="TypeHousing" sm={12}>Tipo de vivienda*</Label><Col sm={12}><Input bsSize="sm" type="select" name="TypeHousing" onChange={handleChangehideOtroTypeHousing} value={props.state.TypeHousing}  >
                            <option>SELECCIONE</option>
                            <option>PROPIA</option>
                            <option>HIPOTECADA</option>
                            <option>RENTADA</option>
                            <option>FAMILIARES</option>
                            <option>OTRO</option>
                        </Input></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_TypeHousing"]}</span>
                        </FormGroup></Col>
                        <Col sm={4} hidden={props.state.hideOtroTypeHousing}> <FormGroup row><Label for="Otro" sm={12}>Especifique*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Otro" onChange={handleChangeTabs} value={props.state.Otro} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Otro"]}</span></FormGroup></Col>

                        <Col sm={4}> <FormGroup row><Label for="YearsResidence" sm={12}>Años residencia*</Label><Col sm={12}><Input bsSize="sm" type="number" name="YearsResidence" onChange={handleChangeTabs} value={props.state.YearsResidence} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_YearsResidence"]}</span></FormGroup></Col>

                    </Row>

                         </Col>
                    <Col sm={1} className="rowArrow">
                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                    </Col>
                    </div>

                    <br /> <br />
                </TabPane>
                <TabPane tabId="3">

                    <div className="rowTitle">
                        <h5 className="PageHeading">INFORMACIÓN LABORAL</h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>
                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>
                            

                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={8}> <FormGroup row><Label for="Empleador" sm={12}>Nombre de la Empresa / Empleador*</Label><Col sm={12}><Input disabled bsSize="sm" type="text" name="Empleador" onChange={handleChangeTabs} value={props.state.Empleador} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Empleador"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="TipodeEmpleo" sm={12}>Tipo de Empleo*</Label><Col sm={12}>


                            <Input bsSize="sm" type="select" name="TipodeEmpleo" onChange={handleChangeTabs} value={props.state.TipodeEmpleo} >
                                <option>SELECCIONE</option>
                                        {props.state.Catalogo.filter(item => item.tipo == 'TIPO DE EMPLEO').map(item => <option>{item.nombre}</option>)}
                            </Input>
                        </Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_TipodeEmpleo"]}</span></FormGroup></Col>

                        <Col sm={6}> <FormGroup row><Label for="IngresosDeclaradosMensuales" sm={12}>Ingresos Declarados Mensuales $*</Label><Col sm={12}><Input bsSize="sm" type="number" name="IngresosDeclaradosMensuales" onChange={handleChangeTabs} value={props.state.IngresosDeclaradosMensuales} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_IngresosDeclaradosMensuales"]}</span></FormGroup></Col>
                        <Col sm={6}> <FormGroup row><Label for="FechaIngreso" sm={12}>Fecha Ingreso*</Label><Col sm={12}><Input bsSize="sm" type="date" name="FechaIngreso" onChange={handleChangeTabs} value={props.state.FechaIngreso} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_FechaIngreso"]}</span>  </FormGroup></Col>
                    </Row>


                        </Col>
                        <Col sm={1} className="rowArrow">
                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>


                        </Col>
                    </div>
                    <br /> <br />
                </TabPane>
                <TabPane tabId="4">
                    <div className="rowTitle">
                        <h5 className="PageHeading">INFORMACION DEL CRÉDITO SOLICITADO </h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>

                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>

                          
                        </Col>
                        <Col sm={10}>
                   
                    <Row className="rowGris">
                        <Col sm={4}> <FormGroup row><Label for="MontoSolicitado" sm={12}>Monto Solicitado*</Label><Col sm={12}><Input bsSize="sm" type="number" name="MontoSolicitado" onChange={handleChangeTabs} value={props.state.MontoSolicitado} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_MontoSolicitado"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="NumeroParcialidades" sm={12}>Numero de Parcialidades*</Label><Col sm={12}><Input bsSize="sm" type="number" name="NumeroParcialidades" onChange={handleChangeTabs} value={props.state.NumeroParcialidades} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NumeroParcialidades"]}</span></FormGroup></Col>
                        <Col sm={4}> <FormGroup row><Label for="MontoPosibleApagar" sm={12}>Monto Máximo posible a pagar*</Label><Col sm={12}><Input bsSize="sm" type="numbers" name="MontoPosibleApagar" onChange={handleChangeMontoPosibleApagar} value={props.state.MontoPosibleApagar} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_MontoPosibleApagar"]}</span></FormGroup></Col>
                        <Col sm={12}> <FormGroup row><Label for="DestinodelCredito" sm={12}>Destino del crédito*</Label><Col sm={12}><Input bsSize="sm" type="select" name="DestinodelCredito" onChange={handleChangeDestinodelCredito} value={props.state.DestinodelCredito} >

                        <option>SELECCIONE</option>
                                    <option>CRÉDITO SIMPLE</option>
                                    <option>CRÉDITO AUTO</option>
                                    <option>CRÉDITO MOTO</option>
                            <option>OTRO</option>
                        </Input>
                        </Col>

                            <span className="col-sm-12 errorInput">{props.state.errors["Error_DestinodelCredito"]}</span> </FormGroup></Col>

                        <Col sm={12} hidden={props.state.hideOtroDestinodelCredito}> <FormGroup row><Label for="OtroDestinodelCredito" sm={12}>Especifique*</Label><Col sm={12}><Input bsSize="sm" type="text" name="OtroDestinodelCredito" onChange={handleChangeTabs} value={props.state.OtroDestinodelCredito} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_OtroDestinodelCredito"]}</span></FormGroup></Col>



                        <Col sm={12}> <FormGroup row><Label for="UsoCredito" sm={12}>Uso del Crédito*</Label><Col sm={12}><Input bsSize="sm" type="textarea" name="UsoCredito" onChange={handleChangeTabs} value={props.state.UsoCredito} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_UsoCredito"]}</span> </FormGroup></Col>
                    </Row>
                    
                         </Col>
                <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                </Col>
                    </div>
                    <br /> <br />
                </TabPane>
                <TabPane tabId="5">
                    <div className="rowTitle">
                        <h5 className="PageHeading">REFERENCIAS PERSONALES<br/>(Familiares o amigos, mayores de 18    años que vivan en la misma ciudad en diferente residencia) </h5>

                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>

                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>
                           
                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={5}> <FormGroup row><Label for="NombreCompleto1" sm={12}>Nombre Completo*</Label><Col sm={12}><Input bsSize="sm" type="text" name="NombreCompleto1" onChange={handleChangeTabs} value={props.state.NombreCompleto1} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NombreCompleto1"]}</span></FormGroup></Col>
                        <Col sm={5}> <FormGroup row><Label for="Parentesco1" sm={12}>Parentesco*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Parentesco1" onChange={handleChangeTabs} value={props.state.Parentesco1} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Parentesco1"]}</span></FormGroup></Col>

                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="Telefono1" sm={12}>Telefono*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Telefono1" onChange={handleChangeTabs} value={props.state.Telefono1} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Telefono1"]}</span></FormGroup></Col>


                        <Col sm={5}> <FormGroup row><Label for="NombreCompleto2" sm={12}>Nombre Completo*</Label><Col sm={12}><Input bsSize="sm" type="text" name="NombreCompleto2" onChange={handleChangeTabs} value={props.state.NombreCompleto2} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NombreCompleto2"]}</span></FormGroup></Col>
                        <Col sm={5}> <FormGroup row><Label for="Parentesco2" sm={12}>Parentesco*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Parentesco2" onChange={handleChangeTabs} value={props.state.Parentesco2} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Parentesco2"]}</span></FormGroup></Col>

                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="Telefono2" sm={12}>Telefono*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Telefono2" onChange={handleChangeTabs} value={props.state.Telefono2} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Telefono2"]}</span></FormGroup></Col>

                        <Col sm={5}> <FormGroup row><Label for="NombreCompleto3" sm={12}>Nombre Completo*</Label><Col sm={12}><Input bsSize="sm" type="text" name="NombreCompleto3" onChange={handleChangeTabs} value={props.state.NombreCompleto3} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_NombreCompleto3"]}</span></FormGroup></Col>
                        <Col sm={5}> <FormGroup row><Label for="Parentesco3" sm={12}>Parentesco*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Parentesco3" onChange={handleChangeTabs} value={props.state.Parentesco3} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Parentesco3"]}</span></FormGroup></Col>

                        <Col sm={4} md={4} lg={2}> <FormGroup row><Label for="Telefono3" sm={12}>Telefono*</Label><Col sm={12}><Input bsSize="sm" type="text" name="Telefono3" onChange={handleChangeTabs} value={props.state.Telefono3} /></Col>
                            <span className="col-sm-12 errorInput">{props.state.errors["Error_Telefono3"]}</span></FormGroup></Col>

                            </Row>

                        </Col>
                        <Col sm={1} className="rowArrow">
                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                        </Col>
                    </div>
                    <br /> <br />

                </TabPane>
                <TabPane tabId="6">
                  
                    
                    <div className="rowTitle">
                        <h5 className="PageHeading">DOCUMENTOS </h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>
                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>
                           

                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile">INE</Label>


                                <div id="result0"></div>
                                <input type="file" id="files0" name="file0" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button0" value="0" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert0" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert0" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted" >
                                  
                        </FormText>
                            </FormGroup></Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile">INE Reverso</Label>


                                <div id="result9"></div>
                                <input type="file" id="files9" name="file9" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button9" value="9" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert9" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert9" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted" >
                                   
                        </FormText>
                            </FormGroup></Col>


                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile">Comprobante de domicilio</Label>


                                <div id="result1"></div>
                                <input type="file" id="files1" name="file1" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button1" value="1" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert1" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert1" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted">
                                   
                        </FormText>
                            </FormGroup></Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile2">Recibo de nómina</Label>
                                <div id="result2"></div>
                                <input type="file" id="files2" name="file2" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button2" value="2" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert2" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert2" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted">
                                   
                        </FormText>
                            </FormGroup></Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile">Autorización Reportes de Crédito</Label>


                                <div id="result4"></div>
                                <input type="file" id="files4" name="file4" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button4" value="4" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert4" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert4" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted">
                                    <div id="resultTemplate"></div>
                                </FormText>
                            </FormGroup></Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile">Autorización domiciliacion de pagos</Label>


                                <div id="result8"></div>
                                <input type="file" id="files8" name="file8" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button8" value="8" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert8" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert8" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted">
                                    <div id="resultTemplateADP"></div>
                                </FormText>
                            </FormGroup></Col>
                        <Col sm={3}>
                            <FormGroup>
                                <Label for="exampleFile3">Carátula estado de cuenta</Label>
                                <div id="result3"></div>
                                <input type="file" id="files3" name="file3" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                <button disabled={props.state.UploadInProcess} type="button" id="upload-button3" value="3" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                                <Alert color="success" id="UploadAlert3" className="alertHide">
                                    This is a success alert — check it out!
                              </Alert>
                                <Alert color="danger" id="UploadFailAlert3" className="alertHide">
                                    This is a danger alert — check it out!
                              </Alert>
                                <FormText color="muted">
                                   
                                    
                        </FormText>
                            </FormGroup></Col>


                    </Row>
                    
                         </Col>
                <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                </Col>
                    </div>
                    <br /> <br />
                    <Row>
                        <Col sm={12}>
                  
                            <div className="FontNote col-sm-12">- Se debe adjuntar el documento en formato jpg,png,bpm, pdf.</div>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="7">
                              
                    <div className="rowTitle">
                        <h5 className="PageHeading">AUTORIZACIÓN </h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>

                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>

                        </Col>
                        <Col sm={10}>
                    <Row className="rowGris">
                        <Col sm={9}>
                            {props.state.Avisos.filter(item => item.titulo == 'CONFORMIDAD SOLICITUD-CONTRATO.').map(item => <div><b>{item.titulo}</b><div>{item.valor}</div></div>)}
                        </Col>
                        <Col sm={3}>
                            &nbsp;
                <Input bsSize="sm" type="text" name="FirmaNombre" onChange={handleChangeTabs} disabled value={props.state.Nombres.toString() + " " + props.state.ApellidoP.toString() + " " + props.state.ApellidoM.toString()} />
                        &nbsp;
                <Input bsSize="sm" type="text" name="Firma" onChange={handleChangeTabs} value={props.state.Firma} placeholder="Ingresar sus nombres y apellidos" />

                        </Col>
                    </Row>
                    <Row className="rowGris">
                        <Col sm={9}>
                                    {props.state.Avisos.filter(item => item.titulo == 'AUTORIZACIÓN PARA USO DE LA INFORMACIÓN.').map(item => <div><b>{item.titulo}</b><div>{item.valor}</div></div>)}
                        </Col>
                        <Col sm={1} className="textoCentrado">
                            <Input bsSize="sm" type="checkbox" name="aceptarCondiciones" value={props.state.aceptarCondiciones} onChange={handleCheck} />
                        </Col>
                    </Row>
                    <Row className="rowGris">
                        <Col sm={12}>
                            {props.state.Avisos.filter(item => item.titulo == 'AVISO DE PRIVACIDAD.').map(item => <div><b>{item.titulo}</b><div>{item.valor}</div></div>)}
                        </Col>
                    </Row>
                         

              
                        </Col>
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                        </Col>
                    </div>
                    <br /> <br />
                    <Row>
                        <Col sm={12}>
                            <div className="FontNote col-sm-12">- Crédito sujeto al cumplimiento de requisitos, verificación de datos y análisis crediticio. </div>

                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="8">
                    <div className="rowTitle">
                        <h5 className="PageHeading">COMPARTIR LOCALIZACIÓN</h5>
                    </div>
                    <br /> <br />
                    <div className="row ">
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow" onClick={NavigateBefore}><FaChevronLeft /></button>

                            <button type="button" className="btn btoArrow derechaOculta" onClick={NavigateNext}><FaChevronRight /></button>

                           

                        </Col>
                        <Col sm={10}>

                            <Row className="rowGris">
                         
                                <Col sm={12}> <FormGroup row>
                                    <Col sm={9}>

                                    {props.state.Avisos.filter(item => item.titulo == 'AUTORIZACIÓN PARA COMPARTIR UBICACIÓN.').map(item => <div><b>{item.titulo}</b><div>{item.valor}</div></div>)}
                                    </Col>

                                    <Col sm={3}>
                                        &nbsp;

                                        <button type="button" className="btn  btnCompartirUbicacion" onClick={UbicarPesona}><MdMyLocation /> Compartir ubicación*</button>
                                        <a className="InfoLocalizacion" onClick={AlertaInfoUbicacion} >¿Tiene algún problema con la ubicación? <FaInfoCircle /></a>
                                    </Col>
                                     
                                        </FormGroup></Col>
                                <Col sm={12}> <FormGroup row>
                                   <Col sm={12}>
                                    
                                        <Input bsSize="sm" type="text" name="UbicacionAPI" id="UbicacionAPI" hidden="true" className="UbicacionAPI" onChange={handleChangeTabs}  />
                                        <Input bsSize="sm" type="text" name="LongitudAPI" id="LongitudAPI" hidden="true" className="LongitudAPI" onChange={handleChangeTabs}  />
                                        <Input bsSize="sm" type="text" name="LatitudAPI" id="LatitudAPI" hidden="true" className="LatitudAPI" onChange={handleChangeTabs}  />
                                        <div className="row ">
                                        <Col sm={6}>
                                             <p name="UbicacionAPIText" id="UbicacionAPIText" className="UbicacionAPIText"></p>
                                         </Col>
                                         <Col sm={6}>

                                                  
                                            <iframe width="100%" height="400" id="mapaAPI" frameborder="0"  scrolling="no"> </iframe>
                                         
                                     
                                            </Col>
                                        </div>
                                    </Col>
                                </FormGroup></Col>
                              
                            </Row>

                        </Col>
                        <Col sm={1} className="rowArrow">

                            <button type="button" className="btn btoArrow derechaMonitor" onClick={NavigateNext}><FaChevronRight /></button>

                        </Col>
                    </div>
                    <br /> <br />
                </TabPane>
                    
                <Row>
                    <Col sm={12}>
                        <div className="FontNote col-sm-12">- Los campos marcados con (*) son obligatorios </div>
                       
                    </Col>
                </Row>
                <br />
                <br />
                <FormGroup row className="justify-content-md-center">
                
                    <Col sm={1} xs={3}>
                        <Button onClick={cancelarPantalla} className="btn btn-danger">Cancelar</Button>
                    </Col>
                    <Col sm={1} xs={3}>
                        <button type="button" onClick={SaveValidateForm} className="btn btn-info">Guardar</button>
                    </Col>
                    <Col sm={1} xs={3} className="contenedorBTN">

                        <button type="button" onClick={ValidateForm} className="btn btn-success btnOculto btnSiguiente">Solicitar</button>
                    </Col>
                 
                </FormGroup>
                <br />
                <br />
                <br />

            </TabContent>
        </div>
    );
}

export default TabsForm;